import { render, staticRenderFns } from "./TriggerItem.vue?vue&type=template&id=52821530"
import script from "./TriggerItem.vue?vue&type=script&lang=js"
export * from "./TriggerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports